var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import store from "@/app/store/store";
import { Vue, Component } from "vue-facing-decorator";
import { MeClient, UserModel, UserPasswordChangeModel, UpdateUserPasswordCommand, UpdateUserProfileCommand, RoleTypeEnum } from "@/app/api/battery-portal-api";
import { State } from "vuex-facing-decorator";
import { LicenseState } from "@/app/store/modules/license.state";
import { Notifier } from "@/common/utils/notifier";
import { HttpHelper } from "@/app/utils/http-helper";
import { Action } from "vuex-facing-decorator";
import PasswordLegendVue from "@/app/vues/components/password-legend.vue";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const meClient = new MeClient(window.apiUrl);
let ProfileVue = class ProfileVue extends Vue {
    constructor() {
        super(...arguments);
        // simpletons
        this.loaded = false;
        this.working = false;
        this.changingPassword = false;
        // models
        this.profile = new UserModel();
        this.password = new UserPasswordChangeModel();
        this.clientAdmins = new Array();
    }
    created() {
        this.get();
    }
    mounted() {
    }
    ;
    // get
    get() {
        if (this.working)
            return;
        meClient
            .get()
            .then(response => {
            if (!response)
                return;
            this.profile = response;
            if (this.isClient) {
                this.getClientAdmins();
            }
            this.setValues({
                firstName: this.profile.firstName,
                lastName: this.profile.lastName,
                email: this.profile.emailAddress || undefined,
                mobilePhone: this.profile.mobilePhone || undefined,
                workPhone: this.profile.workPhone || undefined,
            });
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
            this.loaded = true;
        });
    }
    ;
    getClientAdmins() {
        meClient
            .getClientAdminUserListForClientUser()
            .then(response => {
            this.clientAdmins = response;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    // set
    save() {
        if (this.working)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            meClient
                .update(new UpdateUserProfileCommand({ requestModel: this.profile }))
                .then(response => {
                if (!response)
                    return;
                Notifier.onOk();
                // todo: update user store...
                this.setImperialMeasurementPreference(this.profile.useImperialMeasurementSystem);
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    ;
    changePassword() {
        if (this.working)
            return;
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            meClient
                .updatePassword(new UpdateUserPasswordCommand({ requestModel: this.password }))
                .then(response => {
                if (!response)
                    return;
                Notifier.onOk("Your password has been successfuly changed.");
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, (ctx) => {
            console.log('ctx', ctx);
            Notifier.onError("Please check that you have correctly entered all password fields.");
        });
        handleSubmitAction();
    }
    ;
    goBack() {
        this.$router.back();
    }
    ;
    requestPasswordChange() {
        this.changingPassword = !this.changingPassword;
        this.setFieldValue('changePassword', this.changingPassword);
        if (this.changingPassword) {
            var self = this;
            setTimeout(function () {
                self.setErrors({
                    currentPassword: undefined,
                    newPassword: undefined,
                    passwordConfirmation: undefined
                });
            }, 50);
        }
    }
    resetPasswordFields() {
    }
    get pageTitle() {
        if (!this.profile)
            return "My Details";
        return `Hello, ${this.profile.userName}`;
    }
    get isClient() {
        return this.profile.roleId == RoleTypeEnum.Client;
    }
    get isAdministrator() {
        return this.profile.roleId == RoleTypeEnum.Administrator || this.profile.roleId == RoleTypeEnum.PowerUser;
    }
    get isThirdPartyAuth() {
        return store.getters["appConfigModule/isThirdPartyAuth"];
    }
    get isCloudHosting() {
        return this.licenseState.isCloud;
    }
    ;
    get canEnableDisableTwoFactorAuth() {
        return this.isAdministrator && !this.isCloudHosting;
    }
    ;
};
__decorate([
    State("licenseModule"),
    __metadata("design:type", typeof (_a = typeof LicenseState !== "undefined" && LicenseState) === "function" ? _a : Object)
], ProfileVue.prototype, "licenseState", void 0);
__decorate([
    Action("setImperialMeasurementPreference", { namespace: "loginModule" }),
    __metadata("design:type", Object)
], ProfileVue.prototype, "setImperialMeasurementPreference", void 0);
ProfileVue = __decorate([
    Component({
        name: "ProfileVue",
        components: { PasswordLegendVue },
        setup() {
            let phoneRegExp = new RegExp("^(?=.*[0-9])[- +()0-9]+$");
            const { errors, setErrors, handleSubmit, defineInputBinds, setValues, setFieldValue } = useForm({
                validationSchema: yup.object({
                    firstName: yup.string().trim().required(),
                    lastName: yup.string().trim().required(),
                    email: yup.string().email(),
                    mobilePhone: yup.string().phoneNumber(),
                    workPhone: yup.string().phoneNumber(),
                    changePassword: yup.boolean(),
                    currentPassword: yup.string().when("changePassword", {
                        is: true,
                        then: (schema) => schema.trim().required(),
                    }),
                    newPassword: yup.string().when("changePassword", {
                        is: true,
                        then: (schema) => schema.customPassword(),
                    }),
                    passwordConfirmation: yup.string().when("changePassword", {
                        is: true,
                        then: (schema) => schema.required().oneOf([yup.ref('newPassword')]),
                    }),
                }),
            });
            const firstNameVal = defineInputBinds('firstName');
            const lastNameVal = defineInputBinds('lastName');
            const emailVal = defineInputBinds('email');
            const mobilePhoneVal = defineInputBinds('mobilePhone');
            const workPhoneVal = defineInputBinds('workPhone');
            const currentPasswordVal = defineInputBinds('currentPassword');
            const newPasswordVal = defineInputBinds('newPassword');
            const confirmPasswordVal = defineInputBinds('passwordConfirmation');
            return {
                errors,
                setErrors,
                handleSubmit,
                setValues,
                setFieldValue,
                firstNameVal,
                lastNameVal,
                emailVal,
                mobilePhoneVal,
                workPhoneVal,
                currentPasswordVal,
                newPasswordVal,
                confirmPasswordVal
            };
        }
    })
], ProfileVue);
export default ProfileVue;
